export default __webpack_public_path__ + "static/media/forgot-password.c2227d23.svg";